<div class="custom-checkbox-container d-flex column">
  <mat-checkbox
    [disableRipple]="false"
    [disabled]="isDisabled"
    [(ngModel)]="isChecked"
    [attr.data-test-id]="testId || 'checkbox'"
    [ngClass]="{ 'medium': isBoldLabel }"
  >
    {{ label }}
  </mat-checkbox>

  <mat-hint *ngIf="inputHint && !hideHint" class="d-flex mt-q color-navi">
    <span class="icon icon-info icon-fs-md mr-q"></span>
    <span class="fs-sm">{{ inputHint }}</span>
  </mat-hint>

  <mat-error *ngIf="isErrorExist && !isDisabled" class="mat-error">
    <span class="icon icon-error fs-md"></span>
    {{ errorMessage }}
  </mat-error>
</div>
